<template>
  <section :class="['jury', separatePage ? 'jury--separate' : '']">
    <div class="jury__wrapper">
      <BaseTitle v-if="!separatePage" class="jury__title" :text="title" />
      <BaseTitle
        v-if="separatePage"
        class="jury__title"
        :text="title"
        :tag="'h1'"
      />
      <BaseText v-show="persons.length === 0" class="jury__empty_text" :text="empty" />
      <AppSlider v-if="persons.length > 0" :items="persons" :extension="'jpg'" />
      <BaseBtn
        v-if="!separatePage && persons.length > 0"
        :text="btnText"
        :customClass="'default'"
        :to="'/jury'"
      />
    </div>
  </section>
</template>

<script>
import AppSlider from '~/components/AppSlider.vue'

export default {
  name: 'JuryBlock',
  props: {
    separatePage: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    empty: {
      type: String
    },
    btnText: {
      type: String
    },
    persons: {
      type: Array,
      required: true
    }
  },
  components: {
    AppSlider
  }
}
</script>

<style lang="scss">
.jury {
  $parent: &;

  &--separate {
    #{$parent}__wrapper {
      &::before {
        top: 100px;
      }
    }
  }

  &__wrapper {
    @include container;

    position: relative;
    padding: 62px 16px 0;
    text-align: center;

    &::before {
      content: '';
      position: absolute;
      z-index: -1;
      top: 0;
      left: -150px;
      width: 452px;
      height: 464px;
      background: url('~/static/img/jury-bg-shape.svg') no-repeat center;
      background-size: cover;
    }
  }

  &__title {
    margin: 0 0 30px;
  }

  .glide {
    &__img {
      display: block;
      margin: 0 auto 23px;
      width: 211px;
      height: 293px;
      object-fit: cover;

      @include easeOut;

    }

    &__caption {
      margin: 0 0 20px;
      font-family: $ToyotaType;
    }

    &__text {
      margin: 0;
    }
  }
}

@include media-min($tablet-width) {
  .jury {
    $parent: &;

    &--separate {
      #{$parent}__wrapper {
        padding: 116px 25px 25px;
      }

      .glide {
        margin-bottom: 0;
      }
    }

    &__wrapper {
      padding: 25px 25px 35px;
    }

    &__title {
      margin-bottom: 55px;
    }

    &__empty_text {
      max-width: 600px;
      margin: 0 auto;
    }
  }
}

@include media-min($desktop-width) {
  .jury {
    $parent: &;

    &--separate {
      #{$parent}__wrapper {
        padding: 124px 60px 0;

        &::before {
          top: 140px;
        }
      }
    }

    &__wrapper {
      padding: 89px 60px 67px;

      &::before {
        top: 148px;
        left: -205px;
        width: 1217px;
        height: 748px;
        background: url('~/static/img/jury-bg-shape@dt.svg') no-repeat center;
        background-size: cover;
      }
    }

    .glide {
      &__img {
        width: 340px;
        height: 471px;
        margin-bottom: 40px;
      }

      &__caption {
        margin: 0 0 16px;
        font-size: 24px;
        line-height: 23px;
      }

      &__text {
        margin: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/JuryBlock.vue